<template>
  <div class="col-xs-12 trivia-heading">
    <div class="trivia-complete-card">
      <trivia-empty-state class="trivia-complete-icon" />
      <h1>{{ $t("TRIVIA_COMPLETE_TITLE") }}</h1>
      <p class="trivia-complete-text">{{ $t("TRIVIA_COMPLETE_TEXT") }}</p>
      <div>
        <a class="btn primary-btn" @click="$router.push({ name: 'categoryDashboard', params: { category: $route.params.category } })">{{
          $t("TRIVIA_COMPLETE_BACK_BUTTON")
        }}</a>
      </div>
    </div>
  </div>
</template>
<!---------------------------------------------------------------------------->
<script>

import TriviaEmptyState from "Components/Svg/TriviaEmptyState";

export default {
  name: "EmptyState",
    components: {TriviaEmptyState},
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss"></style>
